<div class="filter-dialog">
    <div class="header">
        <h1>ФИЛЬТР</h1>
        <button mat-icon-button class="close-button" (click)="onNoClick()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <form class="form" [formGroup]="form">
        <pas-multi-select2 label="Архив"
                           [options]="archiveStatuses"
                           [formControlName]="'archive'">
            <ng-template #optionTemplate let-option>
                {{ option.name }}
            </ng-template>
            <ng-template #selectedTemplate let-selected>
                {{ selected.name }}
            </ng-template>
        </pas-multi-select2>

        <pas-multi-select2 label="Учреждение"
                           [options]="organizations"
                           [formControlName]="'organization'"
                           (input)="dataOrganization.set($event)"
        >
            <ng-template #optionTemplate let-option>
                {{ option.name }}
            </ng-template>
            <ng-template #selectedTemplate let-selected>
                {{ selected.name }}
            </ng-template>
        </pas-multi-select2>

        <pas-multi-select2 label="Тип оценки"
                           [options]="periods"
                           [formControlName]="'period'"

        >
            <ng-template #optionTemplate let-option>
                {{ option.name }}
            </ng-template>
            <ng-template #selectedTemplate let-selected>
                {{ selected.name }}
            </ng-template>
        </pas-multi-select2>

        <pas-multi-select2 label="Год"
                           [options]="years"
                           [formControlName]="'year'"
        >
            <ng-template #optionTemplate let-option>
                {{ option.name }}
            </ng-template>
            <ng-template #selectedTemplate let-selected>
                {{ selected.name }}
            </ng-template>
        </pas-multi-select2>

        <pas-multi-select2 label="Квартал"
                           [options]="quarters"
                           [formControlName]="'quarter'"
        >
            <ng-template #optionTemplate let-option>
                {{ option.name }}
            </ng-template>
            <ng-template #selectedTemplate let-selected>
                {{ selected.name }}
            </ng-template>
        </pas-multi-select2>

        <div>
            <mat-expansion-panel [expanded]="true" class="mat-elevation-z0" [style]="{'background-color': '#F3F4F6' }">
                <mat-expansion-panel-header>
                    <mat-panel-title>Исполнитель оценки</mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <div class="controls">
                        <button
                            class="control"
                            [class.active]="isExecutorDepartment"
                            mat-button
                            (click)="form.get('executorType')!.setValue('Department')">Структурное подразделение
                        </button>
                        <button
                            class="control"
                            [class.active]="isExecutorOrganization"
                            mat-button
                            (click)="form.get('executorType')!.setValue('Organization')">Учреждение
                        </button>
                    </div>
                    <br/>
                    <ng-container *ngTemplateOutlet="whichTemplateToUse"></ng-container>

                    <ng-template #department>
                        <pas-multi-select2 label="Стуктурное подразделение"
                                           [options]="departments"
                                           [formControlName]="'departmentExecutor'"
                                           (input)="dataDepartment.set($event)"
                        >
                            <ng-template #optionTemplate let-option>
                                {{ option.name }}
                            </ng-template>
                            <ng-template #selectedTemplate let-selected>
                                {{ selected.name }}
                            </ng-template>
                        </pas-multi-select2>
                    </ng-template>

                    <ng-template #organization>
                        <pas-multi-select2 label="Учреждение"
                                           [options]="organizations"
                                           [formControlName]="'organizationExecutor'"
                                           (input)="dataOrganization.set($event)"
                        >
                            <ng-template #optionTemplate let-option>
                                {{ option.name }}
                            </ng-template>
                            <ng-template #selectedTemplate let-selected>
                                {{ selected.name }}
                            </ng-template>
                        </pas-multi-select2>
                    </ng-template>

                </div>
            </mat-expansion-panel>
        </div>

        <pas-multi-select2 label="ФИО исполнителя"
                           [options]="users"
                           [formControlName]="'user'"
                           (input)="dataUser.set($event)"
        >
            <ng-template #optionTemplate let-option>
                {{ option.name }}
            </ng-template>
            <ng-template #selectedTemplate let-selected>
                {{ selected.name }}
            </ng-template>
        </pas-multi-select2>

        <pas-multi-select2 label="Статус"
                           [options]="statuses"
                           [formControlName]="'status'"
        >
            <ng-template #optionTemplate let-option>
                {{ option.name }}
            </ng-template>
            <ng-template #selectedTemplate let-selected>
                {{ selected.name }}
            </ng-template>
        </pas-multi-select2>

        <div class="dates">
            <div class="dates__title">Дата проведения оценки</div>
            <div class="dates__controls">
                <div class="dates__control">
                  <mat-form-field
                    appearance="fill"
                  >
                    <mat-label>c:</mat-label>
                    <input matInput [matDatepicker]="pickerFrom" [formControlName]="'dateFrom'">
                    <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                    <mat-datepicker #pickerFrom></mat-datepicker>
                  </mat-form-field>
                </div>
                <div class="dates__control">
                  <div class="dates__control">
                    <mat-form-field
                      appearance="fill"
                    >
                      <mat-label>:по</mat-label>
                      <input matInput [matDatepicker]="pickerFrom1" [formControlName]="'dateTo'">
                      <mat-datepicker-toggle matSuffix [for]="pickerFrom1"></mat-datepicker-toggle>
                      <mat-datepicker #pickerFrom1></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
            </div>
        </div>
        <br/>

    </form>
    <div mat-dialog-actions>
        <button [ngClass]="['btn', form.status==='VALID' ? 'btn-blue': 'btn-gray']"
                [ngStyle]="{color:form.status==='VALID' ? '#fff' : '#777'}"
                mat-button cdkFocusInitial [disabled]="form.status!=='VALID'" (click)="onApply()">Применить
        </button>
        <button class="btn btn-secondary" mat-button (click)="onReset()">Сбросить</button>
    </div>
</div>
